// Icon Configuration
// Centralized icon definitions for consistent usage across the application

export const icons = {
    // Navigation & UI
    search: "bi bi-search",
    close: "bi bi-x",
    externalLink: "pi pi-eye",
    spinner: "bi bi-arrow-clockwise",
    gamepad: "bi bi-joystick",

    // Actions
    add: "bi bi-plus",
    remove: "bi bi-dash",
    edit: "bi bi-pencil",
    delete: "bi bi-trash",
    save: "bi bi-check",
    cancel: "bi bi-x",

    // Status & Indicators
    success: "bi bi-check-circle",
    error: "bi bi-exclamation-triangle",
    warning: "bi bi-exclamation-circle",
    info: "bi bi-info-circle",
    star: "bi bi-star",

    // Navigation
    home: "bi bi-house",
    menu: "bi bi-list",
    user: "bi bi-person",
    settings: "bi bi-gear",

    // Data & Lists
    list: "bi bi-list",
    table: "bi bi-table",
    filter: "bi bi-funnel",
    sort: "bi bi-sort-down",

    // Media
    image: "bi bi-image",
    video: "bi bi-camera-video",
    file: "bi bi-file-earmark",
    download: "bi bi-download",
    upload: "bi bi-upload",

    // Communication
    email: "bi bi-envelope",
    phone: "bi bi-telephone",
    message: "bi bi-chat",
    notification: "bi bi-bell",

    // Business
    money: "bi bi-currency-dollar",
    chart: "bi bi-bar-chart",
    calendar: "bi bi-calendar",
    clock: "bi bi-clock",

    // Games & Entertainment
    game: "bi bi-joystick",
    trophy: "bi bi-trophy",
    gift: "bi bi-gift",
    heart: "bi bi-heart",

    // Security
    lock: "bi bi-lock",
    unlock: "bi bi-unlock",
    shield: "bi bi-shield",
    key: "bi bi-key",

    // Layout
    grid: "bi bi-grid-3x2",
    columns: "bi bi-columns",
    window: "bi bi-window",
    minimize: "bi bi-window-minimize",

    // Utilities
    refresh: "bi bi-arrow-clockwise",
    sync: "bi bi-arrow-repeat",
    copy: "bi bi-clipboard",
    link: "bi bi-link-45deg",
    unlink: "bi bi-link-45deg",

    // Arrows & Direction
    arrowUp: "bi bi-arrow-up",
    arrowDown: "bi bi-arrow-down",
    arrowLeft: "bi bi-arrow-left",
    arrowRight: "bi bi-arrow-right",
    chevronUp: "bi bi-chevron-up",
    chevronDown: "bi bi-chevron-down",
    chevronLeft: "bi bi-chevron-left",
    chevronRight: "bi bi-chevron-right",

    // Social & Communication
    facebook: "bi bi-facebook",
    twitter: "bi bi-twitter",
    linkedin: "bi bi-linkedin",
    instagram: "bi bi-instagram",
    youtube: "bi bi-youtube",

    // Payment & Finance
    creditCard: "bi bi-credit-card",
    wallet: "bi bi-wallet",
    bank: "bi bi-bank",
    receipt: "bi bi-receipt",

    // Analytics & Reports
    analytics: "bi bi-graph-up",
    report: "bi bi-file-text",
    dashboard: "bi bi-speedometer",
    metrics: "bi bi-pie-chart",

    // User Management
    users: "bi bi-people-fill",
    userPlus: "bi bi-person-plus-fill",
    userMinus: "bi bi-person-minus-fill",
    userEdit: "bi bi-person-gear",

    // Content Management
    folder: "bi bi-folder",
    folderOpen: "bi bi-folder2-open",
    document: "bi bi-file-earmark",
    documentEdit: "bi bi-file-earmark-text",

    // System
    power: "bi bi-power",
    wifi: "bi bi-wifi",
    bluetooth: "bi bi-bluetooth",
    battery: "bi bi-battery",

    // Custom/Application Specific
    loyalty: "bi bi-stars",
    casino: "bi bi-diamond",
    poker: "bi bi-suitcase",
    slot: "bi bi-circle-fill",
    bonus: "bi bi-gift",
    spin: "bi bi-arrow-clockwise",
    wheel: "bi bi-circle",
    coin: "bi bi-coin",
    chip: "bi bi-circle",
    card: "bi bi-credit-card",
    jackpot: "bi bi-trophy",
    vip: "bi bi-crown",
    affiliate: "bi bi-person-heart",
    promotion: "bi bi-megaphone",
    quest: "bi bi-bookmark-star",
    task: "bi bi-list-check",
    reward: "bi bi-gift",
    entitlement: "bi bi-key",
    addon: "bi bi-plus-circle",
    package: "bi bi-bag",
    store: "bi bi-shop",
    purchase: "bi bi-wallet",
    redemption: "bi bi-bank",
    verification: "bi bi-eyeglasses",
    fraud: "bi bi-incognito",
    support: "bi bi-chat-heart",
    maintenance: "bi bi-cone-striped",
    security: "bi bi-shield-lock",
    notification: "bi bi-exclamation-diamond",
    popup: "bi bi-tv",
    carousel: "bi bi-images",
    postback: "bi bi-postage",
    targeting: "bi bi-bullseye",
    extremePush: "bi bi-fast-forward-fill",
    amo: "bi bi-postcard",
    luckyWheel: "bi bi-star",
    promoCreditTemplate: "bi bi-gift-fill",
    globalConfig: "bi bi-gear",
    gameProvider: "bi bi-buildings",
    gameCategory: "bi bi-card-list",
    gameCatalog: "bi bi-book",
    paymentProvider: "bi bi-bank2",
    sitewideNotification: "bi bi-exclamation-diamond",
    legalDocument: "bi bi-file-earmark-text",
    bannedDevice: "bi bi-phone",
    bannedDomain: "bi bi-globe-americas",
    bannedIP: "bi bi-wifi",
    referFriend: "bi bi-send-plus",
    dailyBonus: "bi bi-calendar-week",
    purchaseOffer: "bi bi-tags",
    purchaseQueue: "bi bi-clock",
    redemptionQueue: "bi bi-clock",
    verificationQueue: "bi bi-clock",
    customerSupportQueue: "bi bi-clock",
    antiFraudQueue: "bi bi-clock",
    amoQueue: "bi bi-clock",
    featureFlag: "bi bi-flag"
};

// Helper function to get icon with fallback
export const getIcon = (iconName, fallback = "pi pi-question") => {
    return icons[iconName] || fallback;
};

// Export individual icon categories for better organization
export const navigationIcons = {
    search: icons.search,
    close: icons.close,
    externalLink: icons.externalLink,
    home: icons.home,
    menu: icons.menu,
    user: icons.user,
    settings: icons.settings
};

export const actionIcons = {
    add: icons.add,
    remove: icons.remove,
    edit: icons.edit,
    delete: icons.delete,
    save: icons.save,
    cancel: icons.cancel
};

export const statusIcons = {
    success: icons.success,
    error: icons.error,
    warning: icons.warning,
    info: icons.info,
    star: icons.star
};

export const gameIcons = {
    game: icons.game,
    trophy: icons.trophy,
    gift: icons.gift,
    heart: icons.heart,
    loyalty: icons.loyalty,
    casino: icons.casino,
    poker: icons.poker,
    slot: icons.slot,
    bonus: icons.bonus,
    spin: icons.spin,
    wheel: icons.wheel,
    coin: icons.coin,
    chip: icons.chip,
    card: icons.card,
    jackpot: icons.jackpot,
    vip: icons.vip
};

export default icons;
